exports = module.exports = require("../../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".videoCore_3nVjN4N4 {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
exports.locals = {
	"videoCore": "videoCore_3nVjN4N4"
};